import { render } from "./CoursesPageFive.vue?vue&type=template&id=14292bc7"
import script from "./CoursesPageFive.vue?vue&type=script&lang=js"
export * from "./CoursesPageFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__